import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Checkbox from '~/components/shared/CheckBox/CheckBox';
import { Typography, useModals } from '@qred/components-library';
import useTranslate from '~/hooks/useTranslate';
import { RootState } from '~/store/types/sharedTypes';
import useTermAndConditionModal from '~/hooks/useTermAndConditionModal';
import { pushToGtmOnboardingAction } from '~/store/actions/gtmActions';
import { onChangeInputEvent } from '~/types/types';
import { Link } from './TermsAndConditions.styled';
import { updateForm } from '~/store/slices/loanOnboardingOffer.slice';

import PDFViewer from '~/components/shared/PDFViewer/PDFViewer';
import { termsAndConditionPdfSources } from '~/constants/markets';

const TermsAndConditions = () => {
  const t = useTranslate();
  const dispatch = useDispatch();
  const modals = useModals();

  const { openTermAndConditionModal } = useTermAndConditionModal();

  const {
    onboardingOffer: {
      form,
      overview: { granter },
    },
    intl: { market },
    matchedMedia: { mobile },
  } = useSelector((state: RootState) => state);

  const onChange = (event: onChangeInputEvent) => {
    const { checked } = event.target;
    dispatch(updateForm({ offerIsAgreed: checked }));
    dispatch(
      pushToGtmOnboardingAction({
        actionName: 'terms_agreement_change',
        stepActionNumber: 0.3,
      })
    );
  };

  const openModal = () => {
    if (granter && termsAndConditionPdfSources[market][granter]) {
      const fileSrc = termsAndConditionPdfSources[market][granter];
      modals.openModal({
        id: 'terms_and_conditions',
        size: 'xl',
        fullScreen: mobile,
        children: <PDFViewer file={fileSrc} />,
      });
    } else {
      openTermAndConditionModal();
    }
    dispatch(
      pushToGtmOnboardingAction({
        actionName: 'terms_agreement_modal_open',
        stepActionNumber: 0.4,
      })
    );
  };

  return (
    <>
      <Checkbox
        checked={form.offerIsAgreed}
        dataCy="onboarding_offer_terms_and_conditions_checkbox"
        name="offerIsAgreed"
        onChange={onChange}
        validationType="Required"
      >
        <Typography size={'sm'} lineHeight={'xs'}>
          {
            t('OnboardingOffer.TermsAndConditionsConsent', {
              termsAndConditionslinkText: (
                <Link onClick={openModal}>
                  <Typography
                    color="success.700"
                    underline
                    size={'sm'}
                    lineHeight={'xs'}
                  >
                    {t('OnboardingOffer.TermsAndConditionslinkText')}
                  </Typography>
                </Link>
              ),
            }) as string
          }
        </Typography>
      </Checkbox>
    </>
  );
};

export default TermsAndConditions;
